module.exports = new __parcel__URL__("darnah-flood-background.82c04ab6.jpg").toString();